/* コンバーターコンテナ */
.converterContainer {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;
  padding: 0 0.5rem;
}

/* タブスライダー */
.tabSlider {
  position: relative;
  display: flex;
  background: white;
  border-radius: 30px;
  padding: 0.25rem;
  box-shadow: var(--shadow-sm);
  margin: 0 auto;
  max-width: 100%;
  width: 100%;
  overflow: hidden;
  z-index: 1;
}

.tabIndicator {
  position: absolute;
  top: 0.25rem;
  left: 0;
  width: 50%;
  height: calc(100% - 0.5rem);
  background: var(--primary-color);
  border-radius: 30px;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: -1;
}

.tabButton {
  flex: 1;
  padding: 0.75rem 0;
  text-align: center;
  color: var(--text-light);
  background: none;
  border: none;
  cursor: pointer;
  border-radius: 30px;
  font-weight: 500;
  font-size: 0.875rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 2;
  white-space: nowrap;
}

.tabButtonActive {
  color: white;
  font-weight: 600;
  font-size: 1.05rem;
}

/* スワイプヒント */
.swipeHint {
  display: flex;
  justify-content: center;
  margin: 0.5rem 0;
  opacity: 0.6;
}

.swipeIcon {
  font-size: 0.75rem;
  color: var(--text-light);
  animation: fadeInOut 3s infinite;
  padding: 0.25rem 0.75rem;
  background-color: rgba(255, 255, 255, 0.7);
  border-radius: 20px;
  box-shadow: var(--shadow-sm);
}

@keyframes fadeInOut {
  0% { opacity: 0.2; }
  50% { opacity: 0.8; }
  100% { opacity: 0.2; }
}

/* タブビューコンテナ */
.tabViewContainer {
  position: relative;
  width: 100%;
  overflow: hidden;
  background: white;
  border-radius: var(--border-radius);
  box-shadow: var(--shadow-md);
  margin-bottom: 1rem;
}

.tabContentWrapper {
  display: flex;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  width: 200%;
  transform: translateX(0);
}

.tabContent {
  width: 50%;
  flex-shrink: 0;
  padding: 1rem;
  opacity: 0.5;
  transform: scale(0.9);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-sizing: border-box;
  overflow-x: hidden;
}

.tabContentActive {
  opacity: 1;
  transform: scale(1);
}

/* フォーム要素 */
.formGroup {
  margin-bottom: 1rem;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.formGroup label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  font-size: 0.875rem;
  color: var(--text-light);
}

.inputField {
  padding: 0.6rem 0.8rem;
  margin-right: 0.5rem;
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius);
  font-size: 1rem;
  max-width: 100%;
}

.inputField:focus {
  border-color: var(--primary-color);
  outline: none;
  box-shadow: 0 0 0 2px rgba(52, 82, 165, 0.2);
}

/* 結果表示 */
.result {
  margin-top: 1rem;
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;
}

.result h5 {
  margin-bottom: 0.5rem;
  font-weight: 600;
  font-size: 0.875rem;
  color: var(--text-light);
}

.resultBox {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  padding: 1rem;
  background-color: var(--primary-light);
  border-radius: var(--border-radius);
  justify-content: center;
  align-items: flex-start;
}

.resultGrid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;
  width: 100%;
}

.resultItem {
  display: flex;
  flex-direction: column;
}

.resultLabel {
  font-size: 0.85rem;
  color: var(--primary-dark);
  font-weight: 600;
}

.resultValue {
  font-size: 1.1rem;
  font-weight: 600;
}

.resultColumn {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}

/* 元号切り替わり年の表示スタイル */
.eraValueContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
}

.primaryEra {
  font-weight: 600;
}

.secondaryEra {
  font-size: 0.9rem;
  color: var(--text-muted);
}

/* YearConverterのメインコンテンツ */
.mainContent {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;
}

@media (max-width: 480px) {
  .tabButton {
    font-size: 0.9rem;
    padding: 0.7rem 0;
  }
  
  .tabButtonActive {
    font-size: 1rem;
  }
  
  .tabContent {
    padding: 0.75rem;
  }
  
  .resultValue {
    font-size: 1rem;
  }
  
  .inputField {
    font-size: 0.9rem;
    padding: 0.7rem;
  }
}

@media (min-width: 480px) {
  .tabButton {
    font-size: 1rem;
    padding: 0.8rem 0;
  }
  
  .tabButtonActive {
    font-size: 1.15rem;
  }
  
  .tabContent {
    padding: 1.25rem;
  }
  
  .swipeIcon {
    font-size: 0.8rem;
  }
  
  .inputField {
    font-size: 1rem;
    padding: 0.8rem;
  }
}

@media (min-width: 768px) {
  .mainContent,
  .converterContainer {
    padding: 0;
  }
  
  .tabSlider {
    max-width: 500px;
  }
  
  .tabContent {
    padding: 1.5rem;
  }
  
  .result {
    margin-top: 1.25rem;
  }
  
  .resultBox {
    padding: 1.25rem;
  }
  
  .resultValue {
    font-size: 1.2rem;
  }
  
  /* タブレット以上ではスワイプヒントを非表示 */
  .swipeHint {
    display: none;
  }
}

@media (min-width: 992px) {
  .tabSlider {
    max-width: 600px;
  }
  
  .tabContent {
    padding: 1.75rem;
  }
}

.eraChipGroup {
  display: flex;
  flex-wrap: wrap;
  gap: 0.2rem;
  margin-bottom: 0.5rem;
}

.eraChip {
  padding: 0.2rem 0.5rem;
  border-radius: 2rem;
  font-size: 0.85rem;
  background-color: var(--light-gray);
  border: 1px solid transparent;
  cursor: pointer;
  transition: all 0.2s;
  
  /* モバイルタップハイライト無効化 */
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
  outline: none;
}

.eraChip:hover {
  background-color: rgba(52, 82, 165, 0.1);
}

.eraChipActive {
  background-color: var(--primary-light);
  border-color: var(--primary-color);
  color: var(--primary-dark);
  font-weight: 600;
}

/* 双方向変換コンテナ */
.dualConvertContainer {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 1.5rem;
  background-color: white;
  border-radius: var(--border-radius);
  box-shadow: var(--shadow-md);
  width: 100%;
}

/* 入力行 */
.dualInputRow {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  gap: 1.5rem;
  width: 100%;
}

.dualInputCol {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  flex: 1;
  min-width: 200px;
}

/* フォームラベル */
.formLabel {
  font-weight: 600;
  font-size: 0.9rem;
  color: var(--primary-dark);
}

/* レスポンシブデザイン */
@media (max-width: 767px) {
  
  .resultBox {
    gap: 1.5rem;
  }
}

@media (min-width: 768px) {
  .eraChip {
    padding: 0.4rem 1rem;
    font-size: 0.9rem;
  }
  
  .resultValue {
    font-size: 1.2rem;
  }
}

/* 西暦入力のコントロール */
.inputWithControls {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.miniControls {
  display: flex;
  gap: 0.2rem;
  margin-left: 0.5rem;
}

.miniButton {
  padding: 0.25rem 0.5rem;
  background-color: var(--light-gray);
  border: 1px solid transparent;
  border-radius: 1rem;
  color: var(--text-dark);
  font-size: 0.7rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  min-width: 2rem;
  height: 1.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  
  /* モバイルタップハイライト無効化 */
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
  
  /* フォーカス時のアウトライン除去 */
  outline: none;
}

.miniButton:hover {
  background-color: rgba(52, 82, 165, 0.1);
}

.miniButton:active {
  background-color: rgba(52, 82, 165, 0.15);
  transform: scale(0.95);
}

.miniButton:focus {
  background-color: rgba(52, 82, 165, 0.1);
  outline: none;
}

@media (min-width: 480px) {
  .miniButton {
    padding: 0.3rem 0.6rem;
    font-size: 0.75rem;
    min-width: 2.25rem;
    height: 2rem;
  }
  
  .miniControls {
    gap: 0.2rem;
  }
}

@media (min-width: 768px) {
  .miniButton {
    font-size: 0.8rem;
    min-width: 2.5rem;
  }
}

/* ダークモード対応 */
/* ダークモード対応 - グローバル変数を使用 */
@media (prefers-color-scheme: dark) {
  .tabSlider,
  .tabViewContainer,
  .dualConvertContainer {
    background-color: var(--dark-bg-secondary, #1e1e1e);
    border: 1px solid var(--dark-border, #3c4043);
  }
  
  .tabContent {
    background-color: transparent;
    color: var(--dark-text, #e1e3e6);
  }
  
  .inputField {
    background-color: var(--dark-bg-tertiary, #2d2d2d);
    border-color: var(--dark-border, #3c4043);
    color: var(--dark-text, #e1e3e6);
  }
  
  .inputField:focus {
    background-color: var(--dark-bg-secondary, #1e1e1e);
    border-color: var(--primary-color, #7bb3ff);
  }
  
  .resultBox {
    background-color: var(--dark-bg-secondary, #1e1e1e);
    border: 1px solid var(--dark-border, #3c4043);
  }
  
  .resultLabel {
    color: var(--primary-color, #7bb3ff);
  }
  
  .resultValue {
    color: var(--dark-text, #e1e3e6);
  }
  
  .swipeIcon {
    background-color: rgba(255, 255, 255, 0.08);
    color: var(--dark-text-secondary, #bdc1c6);
  }
  
  .eraChip {
    background-color: var(--dark-bg-tertiary, #2d2d2d);
    color: var(--dark-text, #e1e3e6);
    border-color: var(--dark-border, #3c4043);
  }
  
  .eraChip:hover {
    background-color: var(--dark-surface, #242424);
  }
  
  .eraChipActive {
    background-color: var(--primary-color, #7bb3ff);
    color: white;
    border-color: var(--primary-color, #7bb3ff);
  }
  
  .miniButton {
    background-color: var(--dark-bg-tertiary, #2d2d2d);
    color: var(--dark-text, #e1e3e6);
    border-color: var(--dark-border, #3c4043);
  }
  
  .miniButton:hover {
    background-color: var(--dark-surface, #242424);
  }
} 